<template>
    <div class="app-loading">
        <div class="lottie-loader">
            <lottie-animation path="lottie/dots.json" />
        </div>
    </div>
</template>
<script>
export default {
    name: 'AppLoading'
}
</script>
<style lang="scss" scoped>
.app-loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: $highest;
    font-size: 3rem;
    background: var(--background);
}
.lottie-loader {
    height: 20%;
}
</style>
